<script>
    import Navbar from './navbar.svelte'
    import PhoneInfo from './phone-info.svelte'
    import NavbarTextIcons from './navbar-text-icons.svelte'
    import NextEventLabel from './nextevent-label.svelte'
    import NextEventText from './nextevent-text.svelte'
    import TodayLabel from './today-label.svelte'
    import TodayText from './today-text.svelte'
    import SponsorLabel from './sponsor-label.svelte'
    import SponsorText from './sponsor-text.svelte'
    import BottomButtonBar from '../shared/bottom-button-bar.svelte'

    export let theme
    export let primary
    export let secondary
    export let accentColor
    export let tabBarHighlightTextColor

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'schedule-background-dark.png' : 'schedule-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <Navbar fill={primary} />
    <PhoneInfo />
    <NavbarTextIcons />
    <NextEventLabel fill={accentColor} />
    <NextEventText />
    <TodayLabel fill={secondary} />
    <TodayText fill={tabBarHighlightTextColor} />
    <SponsorLabel fill={primary} />
    <SponsorText />

    <BottomButtonBar fill={primary} />
</div>
